import { useFormAutoSubmit, useFormGqlMutation } from '@graphcommerce/ecommerce-ui'
import { Trans } from '@lingui/react'
import { Box, Switch } from '@mui/material'
import { useContext, useState } from 'react'
import { globalContext } from '../../NextUi/globalContext'
import { AlertPrompt } from '../../Prompt/AlertPrompt'
import { Spinner } from '../../Spinner'
import { UpdateCustomerIsCompanyAccountDocument } from './UpdateCustomerIsCompanyAccount.gql'

export function SwitchCompanyAccount() {
  const { isCompanyAccount } = useContext(globalContext)
  const form = useFormGqlMutation(UpdateCustomerIsCompanyAccountDocument, {
    mode: 'onSubmit',
    defaultValues: {
      isCompanyAccount,
    },
  })
  const [displayPrompt, setDisplayPrompt] = useState<boolean>(false)

  const handleClosePrompt = () => {
    setDisplayPrompt(false)
  }

  const { handleSubmit, watch, setValue } = form
  const submit = handleSubmit(() => {
    setDisplayPrompt(true)
  })
  useFormAutoSubmit({ form, submit, fields: ['isCompanyAccount'] })

  return (
    <Box component='form' onSubmit={submit} noValidate className='flex items-center'>
      <Switch
        checked={!!watch('isCompanyAccount')}
        onChange={(event, checked) => {
          setValue('isCompanyAccount', checked, {
            shouldDirty: true,
          })
        }}
        disabled={isCompanyAccount}
      />
      <span className='Type-Large-Medium'>
        <Trans id='Is Company Account' />
      </span>
      {form.formState.isSubmitting && <Spinner className='ml-[10px]' />}
      <AlertPrompt
        title='Congratulations'
        message='You are now a company account!'
        isDisplayed={displayPrompt}
        setIsDisplayed={setDisplayPrompt}
        callback={handleClosePrompt}
      />
    </Box>
  )
}
